import { PageMotion } from 'src/components/layout/page-motion.tsx';

import { Eyebrow } from '../components/ui/eyebrow.tsx';

export function NotFound() {
  return (
    <PageMotion>
      <div className="mx-auto max-w-2xl px-5 lg:px-10 py-24 text-center">
        <Eyebrow>404</Eyebrow>
        <h1
          className="mt-4 text-4xl tracking-tight text-zeb-tertiary"
          style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, letterSpacing: '-0.02em' }}>
          Seite nicht gefunden
        </h1>
        <p className="mt-4 text-zeb-gray-600">Die angeforderte Seite existiert nicht.</p>
        <div className="mt-8">
          <a
            href="/"
            className="inline-flex items-center justify-center rounded-sm bg-zeb-primary px-7 py-3.5 text-white hover:bg-zeb-primary-hover"
            style={{ fontWeight: 600 }}>
            Zur Startseite
          </a>
        </div>
      </div>
    </PageMotion>
  );
}
